import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

function GradientCircularProgress({ loadingMessage, additionalCircularSxProps = {}, containerSxProps = {} }) {
  return (
    <Box sx={{ ...containerSxProps }}>
      <p>{loadingMessage}</p>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="dxe_g" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#00FFCF" />
            <stop offset="100%" stopColor="#C630E9" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress sx={{ 'svg circle': { stroke: 'url(#dxe_g)' }, ...additionalCircularSxProps }} />
    </Box>
  );
}

GradientCircularProgress.propTypes = {
  loadingMessage: PropTypes.string,
};

GradientCircularProgress.defaultProps = {
  loadingMessage: 'Loading...',
};

export default GradientCircularProgress;
